import { useQuery } from '@tanstack/react-query';
import { getPaymentOptions } from '@/lib/api/donations';
import { useRegionDetection } from './useRegionDetection';

/**
 * Hook to fetch available payment options
 * Omit region to let backend detect from IP (more reliable for VPN seekers)
 */
export function usePaymentOptions() {
  const { locale, timezone } = useRegionDetection();

  return useQuery({
    queryKey: ['payment-options', locale, timezone],
    queryFn: () =>
      getPaymentOptions({
        // We omit 'region' so backend can perform IP-based detection
        // locale,
        // timezone,
      }),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
